import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=757f6bae&scoped=true&"
import script from "./newsItem.vue?vue&type=script&lang=js&"
export * from "./newsItem.vue?vue&type=script&lang=js&"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=757f6bae&scoped=true&lang=css&"
import style1 from "./newsItem.vue?vue&type=style&index=1&id=757f6bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f6bae",
  null
  
)

export default component.exports